import React from "react";

import Routes from "./components/client/Routes";

const App = () => 
  <div className="center">
    <div className="content">
      <Routes /> 
    </div>
  </div>;

export default App;



// WEBPACK FOOTER //
// ./src/App.js